(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.faqs').forEach(function(faq) {
    faq.querySelectorAll('h3').forEach(function(h3) {
      if (h3.dataset.faqInit) return;
      h3.dataset.faqInit = 'true';

      var panel = document.createElement('div');
      panel.className = 'faq-answer';
      var next = h3.nextElementSibling;
      while (next && next.tagName !== 'H3') {
        var el = next;
        next = next.nextElementSibling;
        panel.appendChild(el);
      }

      // Functional styles inline so behavior doesn't depend on the stylesheet
      panel.style.maxHeight = '0';
      panel.style.overflow = 'hidden';
      panel.style.transition = 'max-height 0.3s ease';

      h3.insertAdjacentElement('afterend', panel);

      h3.classList.add('faq-question');
      h3.setAttribute('role', 'button');
      h3.setAttribute('tabindex', '0');
      h3.setAttribute('aria-expanded', 'false');

      function toggle() {
        var isOpen = h3.classList.toggle('is-open');
        h3.setAttribute('aria-expanded', isOpen);
        panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0';
      }

      h3.addEventListener('click', toggle);
      h3.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
